import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Button, 
  Typography, 
  Alert,
  Divider
} from '@mui/material';
import { CheckCircle, Email, Phone, Info } from '@mui/icons-material';

const SuccessPage = () => {
  const handleCloseWindow = () => {
    window.close();
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', py: 4 }}>
      <Box sx={{ maxWidth: 600, mx: 'auto', px: 2 }}>
        <Card>
          <CardContent sx={{ p: 4 }}>
            {/* Success Icon and Title */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <CheckCircle sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
              <Typography variant="h4" fontWeight="bold" gutterBottom>
                Information Submitted Successfully!
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Thank you for providing your recipient information
              </Typography>
            </Box>

            {/* Success Message */}
            <Alert severity="success" sx={{ mb: 4 }}>
              <Typography variant="body1">
                Your information has been successfully recorded. The e-invoice will be generated and sent to your email address shortly.
              </Typography>
            </Alert>

            {/* Next Steps */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                What happens next?
              </Typography>
              <Box component="ul" sx={{ pl: 2, '& li': { mb: 1 } }}>
                <Typography component="li" variant="body2">
                  Your e-invoice will be processed and generated within the next few minutes
                </Typography>
                <Typography component="li" variant="body2">
                  You will receive the e-invoice via email at the address you provided
                </Typography>
                <Typography component="li" variant="body2">
                  The e-invoice will be compliant with Malaysian LHDN requirements
                </Typography>
                <Typography component="li" variant="body2">
                  Keep the e-invoice for your records and tax purposes
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Important Notes */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                <Info sx={{ mr: 1 }} />
                Important Notes
              </Typography>
              <Box component="ul" sx={{ pl: 2, '& li': { mb: 1 } }}>
                <Typography component="li" variant="body2" color="text.secondary">
                  Please check your email inbox and spam folder for the e-invoice
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary">
                  If you don't receive the e-invoice within 30 minutes, please contact the clinic
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary">
                  The e-invoice is legally valid for tax and business purposes
                </Typography>
              </Box>
            </Box>

            {/* Contact Information */}
            <Box sx={{ mb: 4, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Need Help?
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Email sx={{ mr: 1, fontSize: 20 }} />
                  <Typography variant="body2">
                    Email: support@clinic.com
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Phone sx={{ mr: 1, fontSize: 20 }} />
                  <Typography variant="body2">
                    Phone: +60 3-1234 5678
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Close Button */}
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleCloseWindow}
                sx={{ minWidth: 200 }}
              >
                Close Window
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default SuccessPage;